export default __webpack_public_path__ + "static/media/Version (4) - Half-Blood Prince_07.82da03c3.jpg";